import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../util/utils';
import {useCanvasFormMetadata} from '../../../../../util/customHooks';
import {actionIcInfoOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';
import RedirectLinkContainer from '../../RelateRiskFactorsToRisk/RiskFactorsLink/RedirectLinkContainer';
import Icon from '../../../BaseComponentWrappers/MotifIcon';

export default function RiskFactorUnassociatedLabel({headerId, sectionId}) {
	const riskFactors = useSelector((store) => store.riskFactors);
	const {isTargetEngagement} = useCanvasFormMetadata();

	let unrelatedRiskCount =
		riskFactors !== undefined && riskFactors.length > 0
			? riskFactors?.filter((item) => !item.riskId && !item.isNotMaterial).length
			: 0;

	return (
		<StyledRiskFactorUnassociatedLabel className="StyledRiskFactorUnassociatedLabel">
			{unrelatedRiskCount > 0 && (
				<section className={`unassociated-risk-factors-count`}>
					<Icon src={actionIcInfoOutline24px} />
					{`${unrelatedRiskCount} ${labels.countUnassociatedRisk}`}
					{isTargetEngagement && <RedirectLinkContainer headerId={headerId} sectionId={sectionId} />}
				</section>
			)}
		</StyledRiskFactorUnassociatedLabel>
	);
}

const StyledRiskFactorUnassociatedLabel = styled.section`
	margin: 0 var(--px-10) 0 0;
	.unassociated-risk-factors-count {
		font-size: var(--px-14);
		display: inline-flex;
		align-items: center;
	}
	.motif-icon {
		display: inline-block;
		color: var(--red-600);
		margin-right: var(--px-5);
		margin-top: calc(var(--px-2) * -1);
		vertical-align: middle;
		svg {
			width: var(--px-17) !important;
			height: var(--px-17) !important;
			vertical-align: middle;
		}
	}
`;
